import { getFilterIndicator } from "../helpers";

import type { FilterStrategy } from "./types";

export const sortStrategy: FilterStrategy = {
  search(filterType, ctx, out) {
    if (!filterType.options || filterType.options.length === 0) return;
    const q = ctx.query;
    for (const option of filterType.options) {
      if (option.label.toLowerCase().includes(q)) {
        const isExact = option.label.toLowerCase() === q;
        out.push({
          filterKey: filterType.filterKey,
          filterLabel: filterType.label,
          optionValue: option.value,
          optionLabel: option.label,
          type: filterType.type,
          score: isExact ? 90 : 70,
          indicator: getFilterIndicator(filterType),
        });
      }
    }
  },
  isSelected(currentValue, optionValue) {
    if (
      currentValue &&
      typeof currentValue === "object" &&
      "sortBy" in currentValue
    ) {
      return (currentValue as { sortBy: unknown }).sortBy === optionValue;
    }
    return currentValue === optionValue;
  },
  toggle(result) {
    return {
      value: { sortBy: result.optionValue, sortDirection: "desc" },
    };
  },
};
